import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const verificationAttempted = useRef(false);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }
    
    // Only make the request once
    if (verificationAttempted.current) return;
    verificationAttempted.current = true;
    
    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      console.log('API_BASE:', process.env.REACT_APP_API_BASE);
      console.log('Full URL:', `${process.env.REACT_APP_API_BASE}/auth/verify-email`);
      console.log('Token:', token);
      console.log('Window location:', window.location.href);
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/auth/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();
      console.log('Response status:', response.status);
      console.log('Response data:', data);

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'Email verified successfully! You can now log in.');
      } else {
        setStatus('error');
        setMessage(data.error || 'Email verification failed');
      }
    } catch (error) {
      console.log('Network error:', error);
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  // Make sure the component renders even if status doesn't change
  console.log('Rendering with status:', status);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {status === 'verifying' && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
              <h2 className="mt-4 text-xl font-medium text-gray-900">Verifying your email...</h2>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="text-green-600 text-6xl mb-4">✓</div>
              <h2 className="text-2xl font-bold text-gray-900">Email Verified!</h2>
              <p className="mt-2 text-gray-600">{message}</p>
              <div className="mt-6">
                <Link to="/login" className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md text-sm font-medium">
                  Go to Login
                </Link>
              </div>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="text-red-600 text-6xl mb-4">✗</div>
              <h2 className="text-2xl font-bold text-gray-900">Verification Failed</h2>
              <p className="mt-2 text-gray-600">{message}</p>
              <div className="mt-6 space-x-4">
                <Link to="/signup" className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md text-sm font-medium">
                  Sign Up Again
                </Link>
                <Link to="/login" className="text-green-600 hover:text-green-500 px-6 py-2 text-sm font-medium">
                  Back to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
